import React, { createContext } from 'react';

const ContributorsContext = createContext({});

export { ContributorsContext };
